import {
  Component, EventEmitter, Input, OnInit, Output,
} from '@angular/core';
import {
  brokerIcon, chatIcon, closeIcon, doneIcon, ModalService, optionsIcon, RestApiService, supportIcon, UIKitIconRegistry,
} from '@ui-kit';
import { switchMap } from 'rxjs/operators';
// eslint-disable-next-line import/no-unresolved
import { P } from '@ui-kit/ui-kit';
import { UserService } from '../../../shared/service/user.service';
import { AppService } from '../../../app.service';
import { LeanFavourite, overrideFavouritedListing } from '../shortlist.helpers';

@Component({
  selector: 'app-favourite-thumbnail',
  templateUrl: './favourite-thumbnail.component.html',
  styleUrls: ['./favourite-thumbnail.component.scss'],
})
export class FavouriteThumbnailComponent implements OnInit {
  @Output() update: EventEmitter<any> = new EventEmitter();

  @Input() isRecommended: boolean;

  @Input('favourite') set favourite(favourite: P.Enquiry | LeanFavourite) {
    if (favourite) {
      const data = overrideFavouritedListing(favourite as LeanFavourite);

      this.data = data;

      this.toggle.offerAccepted = !!this.user.myHome
        ? data?.id === this.user.myHome?.id
        : false;
    } else {
      this.data = favourite as LeanFavourite;
    }
  }

  data: LeanFavourite;

  toggle: P.Dictionary<boolean> = {};

  constructor(
    private app: AppService,
    private user: UserService,
    private restApi: RestApiService,
    private modal: ModalService,
    iconRegistry: UIKitIconRegistry,
  ) {
    iconRegistry.registerIcons([
      optionsIcon,
      closeIcon,
      chatIcon,
      doneIcon,
      brokerIcon,
      supportIcon
    ]);
  }

  ngOnInit(): void {
    this.toggle.qualifiesForBookACall = this.user.qualifiesForBookACall;
  }

  bookACall(event: MouseEvent | TouchEvent): void {
    event.stopImmediatePropagation();

    this.app.bookCall('proportunity', 'chat-with-us');
  }

  /**
   *
   */
  offerAccepted(event: MouseEvent | TouchEvent): void {
    event.stopImmediatePropagation();

    this.app.event.emit({ type: 'offer-accepted', data: this.data });
  }

  offerAcceptedRemoved(event: MouseEvent | TouchEvent): void {
    event.stopImmediatePropagation();

    this.modal
      .open('Are you sure?', { ok: 'Yes', cancel: 'No' })
      .then(response => {
        if (response.action === 'ok') {
          this.user
            .updateApplication({
              my_home: null
            })
            .pipe(switchMap(() => this.user.update({}, 'favourite-thumbnail')))
            .toPromise()
            .then(() => this.update.emit())
            .catch((error) => this.modal.open(error?.message || error || 'Opps'));
        }
      });
  }

  archiveFavourite(event: MouseEvent | TouchEvent): void {
    event.stopImmediatePropagation();

    this.modal
      .open('Are you sure?', { ok: 'Yes', cancel: 'No' })
      .then((response) => {
        if (response.action === 'ok') {
          const id = this.data?.id;
          if (id) {
            this.restApi
              .updateEnquiry(id, { status: 'Cancelled' })
              .pipe(switchMap(() => this.user.update({}, 'favourite-thumbnail')))
              .toPromise()
              .then(() => this.update.emit())
              .catch((error) => this.modal.open(error?.message || error || 'Opps'));
          }
        }
      });
  }
}
